module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-f4a46c68.svg";